export type PortalActionAppearance = 'primary' | 'error';

export type PortalActions = {
    type: 'text';
    id: string;
    name: string;
    ariaLabel?: string;
    icon?: string;
    description?: string;
    appearance?: PortalActionAppearance;
    disabled?: boolean;
    variant?: MaterialIconVariant;
} | {
    type: 'icon';
    icon: string;
    id: string;
    name: string;
    ariaLabel?: string;
    disabled?: boolean;
    description?: string;
    appearance?: PortalActionAppearance;
    variant?: MaterialIconVariant;
} | {
    type: 'overflow';
    icon?: string;
    id: string;
    name: string;
    ariaLabel?: string;
    disabled?: boolean;
    appearance?: PortalActionAppearance;
    variant?: MaterialIconVariant;
    description?: string;
};

export enum PortalActionMode {
    text = 'text',
    icon = 'icon',
    overflow = 'overflow',
}

export type MenuPosition = 'space-between' | 'left' | 'right' | 'center';

export interface DropdownOption {
    id: string;
    name: string;
    ariaLabel?: string;
    icon?: string;
    disabled?: boolean;
    isCanaryTenant?: boolean;
}

export type MaterialIconVariant = 'normal' | 'outlined';

